import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Tooltip } from '@creditornot/cb-popover';

import { Stack } from './Stack';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.span`
  color: ${color.textSubdued};
  ${typographyCss.footnoteLabel}
`;

const Content = styled.div`
  ${typographyCss.body}
`;

type Props = React.HTMLAttributes<HTMLDivElement> & {
  label: string;
  className?: string;
  tooltip?: React.ReactNode;
};

export const DetailItem: React.FC<Props> = ({ label, tooltip, className, ...props }) => {
  return (
    <Root className={className}>
      <Stack alignItems="center" direction="row" gap="narrowSmall">
        <Label>{label}</Label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <Icon color={color.text} size="tiny" source={icons.questionCircleFilled} />
          </Tooltip>
        )}
      </Stack>
      <Content {...props} />
    </Root>
  );
};
